import { api } from '@/helpers/apiClient'
import {
  billingEntryDtoSchema,
  billingHistoryDtoSchema,
  opsBillingDtoSchema,
  type BillingEntryDto,
  type BillingHistoryDto,
  type OpsBillingDto,
} from '@lib/dto/billing.dto'
import type { GrantCreditInput } from '@lib/input/billing.input'
import type { Uuid } from '@lib/validators/params'
import type { IOpsBillingService } from '@/types/OpsBillingService.types'

function base(tenantId: Uuid): string {
  return `/ops/tenants/${encodeURIComponent(tenantId)}/billing`
}

/** Staff's view of an organization's billing: balance, history, grants and whether it's billed. */
class OpsBillingService implements IOpsBillingService {
  summary(tenantId: Uuid): Promise<OpsBillingDto> {
    return api.get(base(tenantId), opsBillingDtoSchema)
  }

  history(tenantId: Uuid, before: string | null): Promise<BillingHistoryDto> {
    const search = before ? `?${new URLSearchParams({ before }).toString()}` : ''
    return api.get(`${base(tenantId)}/history${search}`, billingHistoryDtoSchema)
  }

  grant(tenantId: Uuid, input: GrantCreditInput): Promise<BillingEntryDto> {
    return api.post(`${base(tenantId)}/grants`, input, billingEntryDtoSchema)
  }

  setExemption(tenantId: Uuid, exempt: boolean): Promise<OpsBillingDto> {
    return api.patch(`${base(tenantId)}/exemption`, { exempt }, opsBillingDtoSchema)
  }
}

export const opsBillingService = new OpsBillingService()
